<template>
    <div class="sign-sale">
        <div class="sign-sale-header">
            <div @click="handle_duplicate_sign(sign)" v-if="!is_catalog_signs" class="duplicate_btn no-see-in-print">
                <i class="material-icons duplicate_icon">control_point_duplicate</i>
            </div>
            <div v-if="!is_catalog_signs && sign.is_duplicate" @click="handle_remove_duplicate_sign(sign)"
                class="remove_duplicate_btn no-see-in-print">
                <i class="material-icons remove_duplicate_icon">delete</i>
            </div>
        </div>
        <div class="sign-sale-input-texts">
            <div class="he">
                <el-input :input-style="input_style" style="width:100%;" v-if="!is_sales_print"
                    v-model="clone_sign.RemarkForPrint" maxlength="35" placeholder="שם המוצר בעברית" />
                <h1 v-if="is_sales_print" :style="getDynamicStyles">{{ clone_sign?.RemarkForPrint }}</h1>
            </div>
            <i v-if="is_catalog_signs" @click="handle_show_items_list"
                class="material-icons float-icon add-icon">add</i>
        </div>
        <div v-if="!is_catalog_signs" class="sign-sale-contents">
            <div class="col-2 col">
                <el-input :input-style="input_style" type="number" v-if="!is_sales_print" v-model="clone_sign.amount"
                    placeholder="הזן מספר" />
                <h1 v-if="is_sales_print && Number(sign?.amount) > 0.01"> {{ clone_sign.amount }} <span
                        style="font-size:36px;">יח'</span></h1>
                <h1 v-else-if="is_sales_print && Number(sign?.amount) < 1">{{ clone_sign.amount }} <span
                        style="font-size:36px;">ק"ג </span></h1>
            </div>
            <div class="col-1 col">
                <h1>ב-</h1>
            </div>
            <div class="col-2 col">
                <el-input :input-style="input_style" type="number" v-if="!is_sales_print" v-model="clone_sign.sum_price"
                    placeholder="הזן מספר" />
                <h1 v-if="is_sales_print">{{ Number(clone_sign.sum_price).toFixed(1) }}<small> <span
                            style="font-size:36px;"> &#8362;</span></small></h1>
            </div>
        </div>
        <div v-else class="sign-sale-contents catalog">
            <div v-if="!is_sales_print" class="col-2 col">
                <el-input :input-style="input_style" type="number" v-model="clone_sign.price" placeholder="מחיר" />
            </div>
            <div v-if="!is_sales_print" class="col-1 col">
                <h1>ל-</h1>
            </div>
            <div v-if="!is_sales_print" class="col-2 col">
                <el-input :input-style="input_style" v-model="clone_sign.unit" placeholder="הזן יחידת מידה" />
            </div>
            <h1 v-if="is_sales_print">
                {{ clone_sign.price }} &#8362; <span>ל - {{ clone_sign.unit }}</span>
            </h1>
        </div>
        <div v-if="clone_sign?.products?.length > 0" class="sign-sale-footer">
            <div class="col barcodes">
                <h1 style="font-weight:700;" data-fixed>
                    * לחברי מועדון בלבד, ברקוד:
                </h1>
                <h1 style="font-weight:700;" data-slice v-if="clone_sign?.Items?.length > 0">
                    {{ clone_sign.products.slice(0, 6).map(product => product.barcode.slice(-5)).join(",") +
                        (clone_sign.products.length > 6 ? '...' : '')}}
                </h1>
                <h1 style="font-weight:700;" data-slice v-if="clone_sign?.barcode">
                    {{ clone_sign?.barcode.slice(-5) }}
                </h1>
            </div>

            <div v-if="!is_catalog_signs" class="col price">
                <el-input v-if="!is_sales_print" style="font-size: 15px;"
                    :input-style="{ ...input_style, 'font-size': '15px', 'color': '#333' }"
                    v-model="clone_sign.original_price" placeholder="מחיר רגיל ליח' או ל100 גר'" />
                <small v-else>מחיר רגיל: {{ clone_sign.original_price }} &#8362;</small>
            </div>
        </div>
        <div v-else class="sign-sale-footer item-error">
            <h1>
                פריט לא הוקם טוב בקומקס נא לפנות למחלקת סחר
            </h1>
        </div>
        <div v-if="!is_catalog_signs && clone_sign.limitations.filter(lim => lim && lim.trim() && lim != 'לחברי מועדון בלבד').length"
            class="prormo-limit">

            <p>{{ clone_sign.limitations.filter(lim => lim && lim.trim() && lim != 'לחברי מועדון בלבד').join(', ') }}</p>
        </div>
        <div v-if="show_items_list" class="choos-item slide-in-top">
            <ItemsList @back="show_items_list = false; clone_sign = {};" @item_choosen="handle_item_choosen" />
        </div>
    </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import { is_sales_print } from '../../Scripts/scripts'
import { is_catalog_signs } from '../../components/Deals/Scripts/store'
import { computed, defineAsyncComponent, onBeforeUnmount } from 'vue'
import { translate_hebrew_to_russian } from '../../components/Deals/Scripts/script'
import { printer_amount, handle_duplicate_sign, handle_remove_duplicate_sign, is_deleted } from '../../components/Deals/Scripts/store'
import { slide_pop_error } from '../../../../../Methods/Msgs'
import { ElNotification } from 'element-plus'


export default {
    props: ['sign'],
    components: {
        ItemsList: defineAsyncComponent(() => import('../../ItemsList.vue')),
        ErrorTranslateSign: defineAsyncComponent(() => import('../../components/Errors/ErrorTranslateSign.vue'))
    },
    setup(props) {

        // Dynamic product-name sizing — identical thresholds to the Birthday quad sign,
        // with all outputs scaled by ~0.66 to fit the reduced Hot-Sale content area.
        const getDynamicStyles = computed(() => {
            const text = clone_sign.value?.RemarkForPrint || '';
            const length = text.length;

            const hasLineBreak = text.includes('\n') || text.includes('\r');
            const estimatedLines = hasLineBreak ? text.split(/\r?\n/).length :
                (length > 20 ? Math.ceil(length / 20) : 1);

            let fontSize, lineHeight;

            if (estimatedLines > 1) {
                if (length <= 30) {
                    fontSize = '28px';
                    lineHeight = '1.1';
                } else if (length <= 40) {
                    fontSize = '26px';
                    lineHeight = '1.05';
                } else if (length <= 50) {
                    fontSize = '22px';
                    lineHeight = '1';
                } else {
                    fontSize = '19px';
                    lineHeight = '0.95';
                }
            } else {
                if (length <= 25) {
                    fontSize = '34px';
                    lineHeight = '1.2';
                } else if (length <= 35) {
                    fontSize = '30px';
                    lineHeight = '1.15';
                } else if (length <= 45) {
                    fontSize = '26px';
                    lineHeight = '1.1';
                } else if (length <= 55) {
                    fontSize = '22px';
                    lineHeight = '1.05';
                } else {
                    fontSize = '19px';
                    lineHeight = '1';
                }
            }

            return {
                fontWeight: 600,
                fontSize: fontSize,
                lineHeight: lineHeight,
                margin: 0,
                padding: '2px',
                wordBreak: 'break-word',
                whiteSpace: 'pre-wrap',
                overflow: 'hidden',
                maxHeight: '100%'
            };
        });

        const show_error = ref(false)

        const translate_action = ref(false)

        const dotsCount = ref(0);

        // Computed property to display loading dots
        const loadingDots = computed(() => {
            const dots = ['.', '..', '...'];
            return dots[dotsCount.value % dots.length];
        });

        // Increment dotsCount every second
        const interval = setInterval(() => {
            dotsCount.value++;
        }, 1000);

        const handle_translate_to_ru = async (hebrew) => {
            try {
                if (!hebrew) {
                    throw new Error('עליך להזין שם המוצר בעברית תחילה!')
                } else {
                    clone_sign.value.ru_name = null
                    translate_action.value = true
                    clone_sign.value.ru_name = await translate_hebrew_to_russian(hebrew)
                }
            } catch (err) {
                clone_sign.value.ru_name = null
                translate_action.value = false
                slide_pop_error(err.message)
            }
        }

        const handle_show_items_list = () => {
            show_items_list.value = true
            clone_sign.value.ru_name = null
            clone_sign.value.ru_name = null
            translate_action.value = false
        }


        const ru_loader = ref(false)
        const show_items_list = ref(false)

        const clone_sign = ref({})

        const input_style = ref({
            'font-size': '20px',
            'color': 'black',
            'margin-top': '5px',
            'text-align': 'center',
            'border': '2px solid black',
            'border-left': '0',
            'border-right': '0',
            'border-top': '0',
        })

        const handle_item_choosen = (item) => {
            show_items_list.value = false
            clone_sign.value = {
                RemarkForPrint: item.Name,
                barcode: item.barcode,
                price: item.amount == '0.01' ? (Number(item?.price) / 10).toFixed(2) : item?.price,
                amount: item.amount,
                unit: item.amount == '0.01' ? '100 גרם' : 'יח\''
            }
        }

        const handle_translate_manuel = () => {
            clone_sign.value.ru_name = ''
            show_error.value = false
            printer_amount.value.push(1)
        }

        const init = async () => {
            try {
                show_error.value = false
                if (props.sign) {
                    clone_sign.value = JSON.parse(JSON.stringify(props.sign))
                    clone_sign.value.original_price = clone_sign?.value?.products?.[0]?.price;
                    if (Number(props.sign.amount) < 1) {
                        clone_sign.value.amount = Number(props.sign.amount * 100)
                        clone_sign.value.sum_price = (Number(clone_sign.value.sum_price)).toFixed(2)
                    }
                    if (!is_catalog_signs.value && !props.sign.ru_name) {
                        ru_loader.value = false
                        if (!is_deleted.value) printer_amount.value.push(1)
                        clone_sign.value.ru_name = props.sign.ru_name
                        ru_loader.value = true
                    }
                    else if (!is_catalog_signs.value && props.sign.ru_name && !is_deleted.value) {
                        printer_amount.value.push(1)
                    }
                }
            } catch (err) {
                console.log(err.message);
                ElNotification({
                    title: 'נא לשים לב',
                    message: `התרגום לפריט/למבצע ${clone_sign.value.RemarkForPrint} לא הצליח, נא לגלול לשלט לנסות שנית או לתרגם ידנית! `,
                    duration: 0,
                    type: 'warning',
                })
                show_error.value = true
            }
        }

        onBeforeUnmount(() => {
            if (interval) {
                clearInterval(interval);
            }
        })

        init()

        return {
            init,
            is_sales_print,
            input_style,
            clone_sign,
            is_catalog_signs,
            show_items_list,
            handle_item_choosen,
            ru_loader,
            loadingDots,
            translate_action,
            handle_translate_to_ru,
            handle_show_items_list,
            handle_translate_manuel,
            show_error,
            getDynamicStyles,
            handle_duplicate_sign,
            handle_remove_duplicate_sign
        }
    }
}
</script>

<!--
  On-screen editing preview styles.
  Mirror the Birthday quad sign exactly, with every font scaled ~0.66 so the
  preview matches the printed Hot-Sale quad (which is driven by handle_print CSS
  in HotSale/BlankPageSalesFour.vue). h1 keeps its default 2em so the price/amount
  render large and bold, exactly like Birthday.
-->
<style scoped>
.sign-sale {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.sign-sale > * {
    min-height: 0;
}

.sign-sale-header {
    position: relative;
    width: 100%;
    height: 3%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
}

.duplicate_btn,
.remove_duplicate_btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 5px;
    user-select: none;
}

.duplicate_icon,
.remove_duplicate_icon {
    cursor: pointer;
}

.remove_duplicate_btn {
    right: 40px;
}

.remove_duplicate_icon {
    color: var(--danger);
}

.prormo-limit {
    height: 13%;
    width: 100%;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    order: 3;
    overflow: hidden;
    padding: 0 4px;
}

.prormo-limit p {
    margin: 0;
    white-space: nowrap;
    font-size: 14px;
    font-weight: bold;
    color: #000;
}

.sign-sale-input-texts {
    position: relative;
    width: 100%;
    height: 27%;
}

.add-icon,
.clean-icon {
    color: var(--success);
    cursor: pointer;
    font-size: 35px;
    user-select: none;
}

.float-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 50px;
}

.sign-sale-input-texts .he,
.sign-sale-input-texts .ru {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    text-align: center;
}

.sign-sale-contents {
    width: 100%;
    height: 35%;
    display: flex;
    font-size: 44px;
}

.sign-sale-contents.catalog {
    justify-content: center;
    align-items: center;
}

.col {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.col-1 {
    width: 10%;
    height: 100%;
}

.col-2 {
    width: 45%;
    height: 100%;
}

.col.barcodes {
    width: 100%;
    font-size: 13px;
    display: block;
    text-align: right;
    white-space: nowrap;
    order: 2;
    padding: 2px 4px 1px 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #000;
}

.col.barcodes h1 {
    display: inline;
}

.col.small {
    text-align: center;
    width: 30%;
    font-size: 21px;
}

.col.price {
    width: 100%;
    font-size: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    order: 1;
    padding: 1px 0;
}

.col.price>small {
    font-weight: 500;
    font-size: 13px;
    white-space: nowrap;
}

[data-slice] {
    white-space: nowrap;
    overflow: hidden;
    font-size: 13px;
}

[data-fixed] {
    display: flex;
    align-items: center;
    font-size: 13px;
}

.sign-sale-footer {
    width: 100%;
    height: 23%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1px 4px;
    overflow: hidden;
}

.sign-sale-footer.item-error {
    justify-content: center;
    align-items: center;
    color: red;
    font-size: 12px;
}

.choos-item,
.choos-deal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--main);
    z-index: 1000;
}

.slide-in-top {
    -webkit-animation: slide-in-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: slide-in-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

@-webkit-keyframes slide-in-top {
    0% {
        -webkit-transform: translateY(-1000px);
        transform: translateY(-1000px);
        opacity: 0;
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slide-in-top {
    0% {
        -webkit-transform: translateY(-1000px);
        transform: translateY(-1000px);
        opacity: 0;
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}
</style>
